import React from 'react';
import { motion } from 'framer-motion';
export function MethodSection() {
  const pillars = [{
    title: 'ENTRENAMIENTOS INTELIGENTES',
    desc: 'Rutinas cortas, simples y efectivas'
  }, {
    title: 'ALIMENTACIÓN REALISTA',
    desc: 'Sin dietas extremas ni prohibiciones imposibles'
  }, {
    title: 'FLEXIBILIDAD TOTAL',
    desc: 'Se adapta a tu rutina (no al revés)'
  }];
  return <section className="py-8 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-183">
      <div className="text-center mb-8" data-id="element-184">
        <h2 className="font-display text-2xl md:text-3xl font-bold text-gray-900 flex items-center justify-center gap-2" data-id="element-185">
          <span data-id="element-186">🧠</span> Este sistema funciona con 3 pilares:
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-187">
        {pillars.map((pillar, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-white border border-pink-200 rounded-2xl p-6 text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-188">
            <div className="text-brand-accent font-bold text-sm md:text-base mb-3 flex items-center justify-center gap-2" data-id="element-189">
              <span data-id="element-190">🔹</span> {pillar.title}
            </div>
            <p className="text-gray-600 font-medium text-lg" data-id="element-191">{pillar.desc}</p>
          </motion.div>)}
      </div>
    </section>;
}